import React from 'react';

import { testId } from 'ui-components/services/testid-service';

import { CustomsTextInput } from '../customs-text-input';
import { useCustomsContext } from '../../context/context';
import type { CustomsContextValue } from '../../types';
import { CustomsField } from '../customs-field';

import commonStyle from '../common-style.module.less';
import messages from '../messages';

export const CustomsInvoiceNumber = () => {
  const { invoiceNumber, updateInvoiceNumber }: CustomsContextValue = useCustomsContext();

  return (
    <CustomsField label={messages.invoiceNumber} recommended>
      <CustomsTextInput
        {...testId('customs-invoice-flag-input')}
        className={commonStyle['standard-input']}
        onChange={updateInvoiceNumber}
        type='text'
        value={invoiceNumber}
      />
    </CustomsField>
  );
};
